import React, { Component } from 'react';

export class PasswordResetLinkExpirationPage extends Component {

    render = () => {
        return (<p>Your reset password link has expired.</p>);
    }

}


// WEBPACK FOOTER //
// ./src/components/Pages/PasswordResetLinkExpiration/PasswordResetLinkExpirationPage.js